import React, { useCallback, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/sharp-solid-svg-icons/faQuestionCircle';

import { Popover } from 'ui-components/components/popover';
import { useToggle } from 'ui-components/hooks/use-toggle';

import styles from './style.module.less';
import { ServiceLevelPopoverContent } from './service-level-popover-content';

export const ServiceLevelPopover = () => {
  const { activate, deactivate, isActivated } = useToggle(false);
  const popoverWrapperRef = useRef(null);
  const targetRef = useRef(null);

  const togglePopover = useCallback(() => {
    if (isActivated) {
      deactivate();
    } else {
      activate();
    }
  }, [isActivated, activate, deactivate]);

  const backgroundColor = 'var(--grey-200)';
  const props = {
    appendTarget: document.querySelector('#app-root'),
    body: <ServiceLevelPopoverContent />,
    isOpen: isActivated,
    onOuterAction: deactivate,
    place: 'above',
    backgroundColor,
    popoverBodyStyles: '{ box-shadow: none; border: 1px solid var(--grey-300); overflow: hidden;}',
    popoverTipShapeStyles: '{fill: var(--grey-200); stroke: var(--grey-300)}',
    ref: popoverWrapperRef,
    tipSize: 15,
  };

  return (
    <Popover {...props}>
      <div ref={targetRef} className={styles['popover-toggle']} onClick={togglePopover}>
        <FontAwesomeIcon className={styles['popover-toggle-icon']} icon={faQuestionCircle} />
      </div>
    </Popover>
  );
};
